import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TableDataService {
  observableItem$: Observable<any>;
  public data: Subject<any> = new Subject();

  constructor() {
    this.observableItem$ = this.data.asObservable();
   }

   shareData(data) {
    console.log(data);
    this.data.next(data);
  }
}
